import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get productType
export const getProductType = createAsyncThunk("productType/getProductType", async (params, { rejectWithValue }) => {
  try {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    const { data } = await API.getProductType({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all productType
export const getAllProductType = createAsyncThunk("productType/getAllProductType", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllProductType();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("productType/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("productType/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "productType/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageProductType({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create productType
export const createProductType = createAsyncThunk(
  "productType/createProductType",
  async (data, { rejectWithValue }) => {
    const { name, isActive } = data;
    try {
      const body = JSON.stringify({ name, isActive });
      const { data } = await API.createProductType(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updateProductType = createAsyncThunk(
  "productType/updateProductType",
  async (data, { rejectWithValue }) => {
    const { id, values } = data;
    const { name, isActive } = values;
    try {
      const body = JSON.stringify({ name, isActive });
      const { data } = await API.updateProductType(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk("productType/handleSearch", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
